<template>
  <div class="Comment-Reactions-List">
    <ButtonReaction
        class="Comment-Reactions-List__btn"
        @click="handleReactionClick('1')"
        :count="get_reactionCount('1')"
        :isActive="get_isActive('1')"
        :icon="ICON_LIKE"
        v-if="get_isShowReaction('1')"
    />
    <ButtonReaction
        class="Comment-Reactions-List__btn"
        @click="handleReactionClick('-1')"
        :count="get_reactionCount('-1')"
        :isActive="get_isActive('-1')"
        :icon="ICON_DISLIKE"
        v-if="get_isShowReaction('-1')"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
import {changeReaction} from '../../api/changeReaction.js'
//------------------------------
import ButtonReaction from '@ui/Buttons/ButtonReaction/ButtonReaction.vue';
//------------------------------
const props = defineProps(Props());
const store = useStore();
//------------------------------
const COMMENT = props.comment;
const CTX = props.commentsPlace;
//------------------------------
const ICON_LIKE = require('@shared/images/reactions/like.png');
const ICON_DISLIKE = require('@shared/images/reactions/dislike.png');
//------------------------------
//Объект комментария
const get_commentReaction = computed(() => store.state.ContentSystem.Comments[CTX].list.find(item => item.id === COMMENT.id).reactions);
//Получить кол-во реакций
const get_reactionCount = (reaction) => {
  return get_commentReaction.value.find(item => item.reaction == reaction).count;
}
//Отображать ли реакцию в списке
const get_isShowReaction = (reaction) => {
  return get_commentReaction?.value?.some(item => item.reaction == reaction);
}
//Выбрана ли реакция
const get_isActive = (reaction) => {
  return get_commentReaction.value.find(item => item.reaction == reaction).is_mine;
}
//------------------------------
//Отправляем данные на сервер
const handleReactionClick = async (reaction) => {
  const currentReaction = get_commentReaction.value.find(item => item.reaction == reaction);

  // Если реакция уже активна, отменяем её
  if (currentReaction && currentReaction.is_mine) {
    const data = {
      reaction: currentReaction.reaction,
      object_id: COMMENT.id,
    };
    try {
      const response = await changeReaction(data);
      const commentItem = store.state.ContentSystem.Comments[CTX].list.find(item => item.id === COMMENT.id);
      commentItem.reactions = response.reactions;
    } catch (error) {
      console.error("Ошибка отмены реакции:", error);
    }
    return;
  }

  // Если реакция не активна, ставим её
  const data = {
    reaction: reaction,
    object_id: COMMENT.id,
  };
  try {
    const response = await changeReaction(data);
    const commentItem = store.state.ContentSystem.Comments[CTX].list.find(item => item.id === COMMENT.id);
    commentItem.reactions = response.reactions;
  } catch (error) {
    console.error("Ошибка обработки реакции:", error);
  }
};

</script>

<style lang="scss">
@import "styles/_styles";
</style>